module.exports = __webpack_public_path__ + "img/okx_icon.72cbcea0.png";